import HWUser from "../HWLibrary/HWUser";

import { s360ConfigService } from "./S360Config";

const watchForChatSDKEvents = (appComponent) => {
  window.addEventListener(
    "message",
    (messageEvent) => {
      if (!s360ConfigService.isClientHostConfigured() || messageEvent.origin !== s360ConfigService.sourceOrigin){
        // return;
        //preventing return for godaddy error
      }

      try {
        let messageData = JSON.parse(messageEvent.data);
        if (!messageData || messageData.clientHostId !== s360ConfigService.clientHostId || !messageData.action) {
          return;
        }
        switch (messageData.action) {
          case "on-update-user-metadata":
            s360ConfigService.sendUserData(messageData.data);
            break;
          case "on-config-data-update":
            //STEP 6
            s360ConfigService.setConfig(messageData.data);
            appComponent.setRefresh(currentRefresh => !currentRefresh);
            break;
          case "on-reset-user":
            onResetUser();
            break;
          case "chat-maximize":
            appComponent.setChatMaximized(currentChatMaximized => !currentChatMaximized)
            break;
          case "on-set-user-config":
            s360ConfigService.setUserConfig(messageData.data);
            appComponent.setUser(JSON.stringify(messageData.data))
            break;

          default:
            break;
        }
      } catch (error) {
        console.log("Invalid Message Data: ");
      }
    },
    false
  );
};

const onResetUser = () => {
  HWUser.resetUser();
  window.location.reload();
};

const postPlatformMessage = (messageData, actionName) => {
  // STEP 3
  let message = {
    data: messageData,
    action: actionName,
    clientHostId: s360ConfigService.clientHostId,
  };
  try {
    window.parent.postMessage(JSON.stringify(message), "*");
  } catch (error) {
    console.log(error);
  }
};

const fetchConfigDetailsFromClientHost = () => {
  // STEP 2
  postPlatformMessage(null, "update-client-host-config");
};
const checkChangeInConfig =()=> {
  postPlatformMessage(null, "check-config-diffrence");
}
const loadLocalUser =()=>{
  postPlatformMessage(null, "load-local-user");
}
const sendOnAppOpen = () => {

  postPlatformMessage(null, "on-app-open");
};

const sendOnAppClose = () => {
  postPlatformMessage(null, "on-app-close");
};

const requestNotification = () => {
  postPlatformMessage(null, "request-notification");
}


const sendNotification = (notificationMessage) => {
  if (!s360ConfigService?.config?.sandbox) {
    postPlatformMessage(notificationMessage, "notification");
  }
}


export {
  checkChangeInConfig,
  fetchConfigDetailsFromClientHost,
  loadLocalUser,
  requestNotification,
  sendNotification,
  sendOnAppClose,
  sendOnAppOpen,
  watchForChatSDKEvents
};
